export default [
    [
        { t: 0, x: -1.0438, y: 1.4877, z: 2.652 },
        { t: 0.016, x: -0.9859, y: 1.48, z: 3.3177 },
        { t: 0.032, x: -0.9309, y: 1.4701, z: 3.9789 },
        { t: 0.048, x: -0.8788, y: 1.4577, z: 4.6356 },
        { t: 0.064, x: -0.8296, y: 1.4431, z: 5.2878 },
        { t: 0.08, x: -0.7832, y: 1.426, z: 5.9356 },
        { t: 0.096, x: -0.7398, y: 1.4066, z: 6.5788 },
        { t: 0.112, x: -0.6992, y: 1.3849, z: 7.2176 },
        { t: 0.128, x: -0.6615, y: 1.3608, z: 7.8519 },
        { t: 0.144, x: -0.6267, y: 1.3344, z: 8.4818 },
        { t: 0.16, x: -0.5948, y: 1.3056, z: 9.1072 },
        { t: 0.176, x: -0.5658, y: 1.2745, z: 9.7281 },
        { t: 0.192, x: -0.5397, y: 1.241, z: 10.3445 },
        { t: 0.208, x: -0.5164, y: 1.2052, z: 10.9564 },
        { t: 0.224, x: -0.4961, y: 1.167, z: 11.5639 },
        { t: 0.24, x: -0.4786, y: 1.1264, z: 12.1669 },
        { t: 0.256, x: -0.464, y: 1.0835, z: 12.7654 },
        { t: 0.272, x: -0.4523, y: 1.0383, z: 13.3594 },
        { t: 0.288, x: -0.4435, y: 0.9907, z: 13.9489 },
        { t: 0.304, x: -0.4376, y: 0.9407, z: 14.534 },
        { t: 0.32, x: -0.4346, y: 0.8884, z: 15.1146 },
        { t: 0.336, x: -0.4344, y: 0.8338, z: 15.6907 },
        { t: 0.352, x: -0.4371, y: 0.7768, z: 16.2624 },
        { t: 0.368, x: -0.4428, y: 0.7174, z: 16.8296 },
        { t: 0.384, x: -0.4513, y: 0.6557, z: 17.3923 },
        { t: 0.4, x: -0.4627, y: 0.5917, z: 17.9505 },
        { t: 0.4044, x: -0.4663, y: 0.5736, z: 18.1035 }
    ],
    [
        { t: 0, x: -1.1198, y: 1.4347, z: 2.644 },
        { t: 0.016, x: -1.0503, y: 1.4338, z: 3.3054 },
        { t: 0.032, x: -0.9837, y: 1.4303, z: 3.9624 },
        { t: 0.048, x: -0.92, y: 1.4242, z: 4.6148 },
        { t: 0.064, x: -0.8591, y: 1.4155, z: 5.2627 },
        { t: 0.08, x: -0.8012, y: 1.4042, z: 5.9061 },
        { t: 0.096, x: -0.7461, y: 1.3902, z: 6.5449 },
        { t: 0.112, x: -0.6939, y: 1.3736, z: 7.1793 },
        { t: 0.128, x: -0.6445, y: 1.3544, z: 7.8091 },
        { t: 0.144, x: -0.5981, y: 1.3326, z: 8.4344 },
        { t: 0.16, x: -0.5545, y: 1.3081, z: 9.0552 },
        { t: 0.176, x: -0.5138, y: 1.2811, z: 9.6714 },
        { t: 0.192, x: -0.476, y: 1.2514, z: 10.2832 },
        { t: 0.208, x: -0.4411, y: 1.2191, z: 10.8904 },
        { t: 0.224, x: -0.409, y: 1.1842, z: 11.4931 },
        { t: 0.24, x: -0.3799, y: 1.1467, z: 12.0913 },
        { t: 0.256, x: -0.3536, y: 1.1065, z: 12.685 },
        { t: 0.272, x: -0.3302, y: 1.0638, z: 13.2741 },
        { t: 0.288, x: -0.3096, y: 1.0184, z: 13.8587 },
        { t: 0.304, x: -0.292, y: 0.9704, z: 14.4389 },
        { t: 0.32, x: -0.2772, y: 0.9197, z: 15.0145 },
        { t: 0.336, x: -0.2653, y: 0.8665, z: 15.5855 },
        { t: 0.352, x: -0.2563, y: 0.8106, z: 16.1521 },
        { t: 0.368, x: -0.2502, y: 0.7522, z: 16.7141 },
        { t: 0.384, x: -0.2469, y: 0.6911, z: 17.2716 },
        { t: 0.4, x: -0.2466, y: 0.6274, z: 17.8246 },
        { t: 0.408, x: -0.2475, y: 0.5945, z: 18.1 }
    ],
    [
        { t: 0, x: -1.0821, y: 1.4477, z: 2.6345 },
        { t: 0.016, x: -1.0188, y: 1.4487, z: 3.2913 },
        { t: 0.032, x: -0.9585, y: 1.4473, z: 3.9437 },
        { t: 0.048, x: -0.901, y: 1.4437, z: 4.5915 },
        { t: 0.064, x: -0.8466, y: 1.4377, z: 5.2347 },
        { t: 0.08, x: -0.795, y: 1.4295, z: 5.8735 },
        { t: 0.096, x: -0.7465, y: 1.419, z: 6.5077 },
        { t: 0.112, x: -0.7008, y: 1.4062, z: 7.1374 },
        { t: 0.128, x: -0.6581, y: 1.391, z: 7.7625 },
        { t: 0.144, x: -0.6184, y: 1.3736, z: 8.3832 },
        { t: 0.16, x: -0.5816, y: 1.3539, z: 8.9993 },
        { t: 0.176, x: -0.5477, y: 1.3319, z: 9.6109 },
        { t: 0.192, x: -0.5168, y: 1.3076, z: 10.218 },
        { t: 0.208, x: -0.4889, y: 1.281, z: 10.8205 },
        { t: 0.224, x: -0.4638, y: 1.2521, z: 11.4185 },
        { t: 0.24, x: -0.4417, y: 1.2209, z: 12.012 },
        { t: 0.256, x: -0.4226, y: 1.1874, z: 12.6009 },
        { t: 0.272, x: -0.4064, y: 1.1516, z: 13.1854 },
        { t: 0.288, x: -0.3932, y: 1.1135, z: 13.7653 },
        { t: 0.304, x: -0.3829, y: 1.0731, z: 14.3407 },
        { t: 0.32, x: -0.3755, y: 1.0304, z: 14.9115 },
        { t: 0.336, x: -0.3711, y: 0.9855, z: 15.4779 },
        { t: 0.352, x: -0.3696, y: 0.9382, z: 16.0397 },
        { t: 0.368, x: -0.3711, y: 0.8886, z: 16.597 },
        { t: 0.384, x: -0.3755, y: 0.8367, z: 17.1497 },
        { t: 0.4, x: -0.3829, y: 0.7826, z: 17.698 },
        { t: 0.411, x: -0.3897, y: 0.744, z: 18.0726 }
    ],
    [
        { t: 0, x: -1.0802, y: 1.3633, z: 2.5252 },
        { t: 0.016, x: -1.0348, y: 1.3729, z: 3.1245 },
        { t: 0.032, x: -0.9892, y: 1.3775, z: 3.7201 },
        { t: 0.048, x: -0.9435, y: 1.3773, z: 4.3119 },
        { t: 0.064, x: -0.8976, y: 1.3722, z: 4.9 },
        { t: 0.08, x: -0.8515, y: 1.3623, z: 5.4843 },
        { t: 0.096, x: -0.8053, y: 1.3475, z: 6.0649 },
        { t: 0.112, x: -0.7589, y: 1.3278, z: 6.6417 },
        { t: 0.128, x: -0.7124, y: 1.3032, z: 7.2147 },
        { t: 0.144, x: -0.6657, y: 1.2738, z: 7.784 },
        { t: 0.16, x: -0.6188, y: 1.2395, z: 8.3495 },
        { t: 0.176, x: -0.5718, y: 1.2003, z: 8.9113 },
        { t: 0.192, x: -0.5246, y: 1.1563, z: 9.4693 },
        { t: 0.208, x: -0.4773, y: 1.1073, z: 10.0236 },
        { t: 0.224, x: -0.4298, y: 1.0536, z: 10.5741 },
        { t: 0.24, x: -0.3821, y: 0.9949, z: 11.1208 },
        { t: 0.256, x: -0.3343, y: 0.9314, z: 11.6638 },
        { t: 0.272, x: -0.2863, y: 0.863, z: 12.203 },
        { t: 0.288, x: -0.2381, y: 0.7897, z: 12.7385 },
        { t: 0.304, x: -0.1898, y: 0.7115, z: 13.2702 },
        { t: 0.32, x: -0.1413, y: 0.6285, z: 13.7982 },
        { t: 0.336, x: -0.0927, y: 0.5406, z: 14.3224 },
        { t: 0.352, x: -0.0439, y: 0.4479, z: 14.8428 },
        { t: 0.368, x: 0.0051, y: 0.3503, z: 15.3595 },
        { t: 0.384, x: 0.0542, y: 0.2478, z: 15.8724 },
        { t: 0.4, x: 0.1035, y: 0.1404, z: 16.3816 },
        { t: 0.416, x: 0.153, y: 0.0281, z: 16.887 },
        { t: 0.432, x: 0.2026, y: -0.089, z: 17.3887 },
        { t: 0.448, x: 0.2523, y: -0.211, z: 17.8866 },
        { t: 0.4557, x: 0.2764, y: -0.2715, z: 18.1254 }
    ],
    [
        { t: 0, x: -1.1526, y: 1.4483, z: 2.5141 },
        { t: 0.016, x: -1.0646, y: 1.4478, z: 3.1446 },
        { t: 0.032, x: -0.9794, y: 1.444, z: 3.771 },
        { t: 0.048, x: -0.8971, y: 1.4369, z: 4.3935 },
        { t: 0.064, x: -0.8176, y: 1.4265, z: 5.0119 },
        { t: 0.08, x: -0.7409, y: 1.4128, z: 5.6263 },
        { t: 0.096, x: -0.6671, y: 1.3958, z: 6.2368 },
        { t: 0.112, x: -0.5961, y: 1.3754, z: 6.8432 },
        { t: 0.128, x: -0.5279, y: 1.3518, z: 7.4457 },
        { t: 0.144, x: -0.4626, y: 1.3249, z: 8.0441 },
        { t: 0.16, x: -0.4001, y: 1.2946, z: 8.6385 },
        { t: 0.176, x: -0.3404, y: 1.2611, z: 9.229 },
        { t: 0.192, x: -0.2836, y: 1.2242, z: 9.8154 },
        { t: 0.208, x: -0.2295, y: 1.1841, z: 10.3978 },
        { t: 0.224, x: -0.1783, y: 1.1406, z: 10.9763 },
        { t: 0.24, x: -0.13, y: 1.0939, z: 11.5507 },
        { t: 0.256, x: -0.0845, y: 1.0438, z: 12.1211 },
        { t: 0.272, x: -0.0418, y: 0.9904, z: 12.6876 },
        { t: 0.288, x: -0.0019, y: 0.9337, z: 13.25 },
        { t: 0.304, x: 0.0351, y: 0.8738, z: 13.8084 },
        { t: 0.32, x: 0.0693, y: 0.8105, z: 14.3629 },
        { t: 0.336, x: 0.1007, y: 0.7439, z: 14.9133 },
        { t: 0.352, x: 0.1292, y: 0.674, z: 15.4597 },
        { t: 0.368, x: 0.1549, y: 0.6008, z: 16.0022 },
        { t: 0.384, x: 0.1778, y: 0.5243, z: 16.5406 },
        { t: 0.4, x: 0.1979, y: 0.4445, z: 17.075 },
        { t: 0.416, x: 0.2151, y: 0.3613, z: 17.6054 },
        { t: 0.432, x: 0.2295, y: 0.2749, z: 18.1319 },
        { t: 0.433, x: 0.2303, y: 0.2692, z: 18.1657 }
    ],
    [
        { t: 0, x: -1.0438, y: 1.4877, z: 2.652 },
        { t: 0.016, x: -0.9859, y: 1.48, z: 3.3177 },
        { t: 0.032, x: -0.9309, y: 1.4701, z: 3.9789 },
        { t: 0.048, x: -0.8788, y: 1.4577, z: 4.6356 },
        { t: 0.064, x: -0.8296, y: 1.4431, z: 5.2878 },
        { t: 0.08, x: -0.7832, y: 1.426, z: 5.9356 },
        { t: 0.096, x: -0.7398, y: 1.4066, z: 6.5788 },
        { t: 0.112, x: -0.6992, y: 1.3849, z: 7.2176 },
        { t: 0.128, x: -0.6615, y: 1.3608, z: 7.8519 },
        { t: 0.144, x: -0.6267, y: 1.3344, z: 8.4818 },
        { t: 0.16, x: -0.5948, y: 1.3056, z: 9.1072 },
        { t: 0.176, x: -0.5658, y: 1.2745, z: 9.7281 },
        { t: 0.192, x: -0.5397, y: 1.241, z: 10.3445 },
        { t: 0.208, x: -0.5164, y: 1.2052, z: 10.9564 },
        { t: 0.224, x: -0.4961, y: 1.167, z: 11.5639 },
        { t: 0.24, x: -0.4786, y: 1.1264, z: 12.1669 },
        { t: 0.256, x: -0.464, y: 1.0835, z: 12.7654 },
        { t: 0.272, x: -0.4523, y: 1.0383, z: 13.3594 },
        { t: 0.288, x: -0.4435, y: 0.9907, z: 13.9489 },
        { t: 0.304, x: -0.4376, y: 0.9407, z: 14.534 },
        { t: 0.32, x: -0.4346, y: 0.8884, z: 15.1146 },
        { t: 0.336, x: -0.4344, y: 0.8338, z: 15.6907 },
        { t: 0.352, x: -0.4371, y: 0.7768, z: 16.2624 },
        { t: 0.368, x: -0.4428, y: 0.7174, z: 16.8296 },
        { t: 0.384, x: -0.4513, y: 0.6557, z: 17.3923 },
        { t: 0.4, x: -0.4627, y: 0.5917, z: 17.9505 },
        { t: 0.4044, x: -0.4663, y: 0.5736, z: 18.1035 }
    ],
    [
        { t: 0, x: -1.1198, y: 1.4347, z: 2.644 },
        { t: 0.016, x: -1.0503, y: 1.4338, z: 3.3054 },
        { t: 0.032, x: -0.9837, y: 1.4303, z: 3.9624 },
        { t: 0.048, x: -0.92, y: 1.4242, z: 4.6148 },
        { t: 0.064, x: -0.8591, y: 1.4155, z: 5.2627 },
        { t: 0.08, x: -0.8012, y: 1.4042, z: 5.9061 },
        { t: 0.096, x: -0.7461, y: 1.3902, z: 6.5449 },
        { t: 0.112, x: -0.6939, y: 1.3736, z: 7.1793 },
        { t: 0.128, x: -0.6445, y: 1.3544, z: 7.8091 },
        { t: 0.144, x: -0.5981, y: 1.3326, z: 8.4344 },
        { t: 0.16, x: -0.5545, y: 1.3081, z: 9.0552 },
        { t: 0.176, x: -0.5138, y: 1.2811, z: 9.6714 },
        { t: 0.192, x: -0.476, y: 1.2514, z: 10.2832 },
        { t: 0.208, x: -0.4411, y: 1.2191, z: 10.8904 },
        { t: 0.224, x: -0.409, y: 1.1842, z: 11.4931 },
        { t: 0.24, x: -0.3799, y: 1.1467, z: 12.0913 },
        { t: 0.256, x: -0.3536, y: 1.1065, z: 12.685 },
        { t: 0.272, x: -0.3302, y: 1.0638, z: 13.2741 },
        { t: 0.288, x: -0.3096, y: 1.0184, z: 13.8587 },
        { t: 0.304, x: -0.292, y: 0.9704, z: 14.4389 },
        { t: 0.32, x: -0.2772, y: 0.9197, z: 15.0145 },
        { t: 0.336, x: -0.2653, y: 0.8665, z: 15.5855 },
        { t: 0.352, x: -0.2563, y: 0.8106, z: 16.1521 },
        { t: 0.368, x: -0.2502, y: 0.7522, z: 16.7141 },
        { t: 0.384, x: -0.2469, y: 0.6911, z: 17.2716 },
        { t: 0.4, x: -0.2466, y: 0.6274, z: 17.8246 },
        { t: 0.408, x: -0.2475, y: 0.5945, z: 18.1 }
    ],
    [
        { t: 0, x: -1.0821, y: 1.4477, z: 2.6345 },
        { t: 0.016, x: -1.0188, y: 1.4487, z: 3.2913 },
        { t: 0.032, x: -0.9585, y: 1.4473, z: 3.9437 },
        { t: 0.048, x: -0.901, y: 1.4437, z: 4.5915 },
        { t: 0.064, x: -0.8466, y: 1.4377, z: 5.2347 },
        { t: 0.08, x: -0.795, y: 1.4295, z: 5.8735 },
        { t: 0.096, x: -0.7465, y: 1.419, z: 6.5077 },
        { t: 0.112, x: -0.7008, y: 1.4062, z: 7.1374 },
        { t: 0.128, x: -0.6581, y: 1.391, z: 7.7625 },
        { t: 0.144, x: -0.6184, y: 1.3736, z: 8.3832 },
        { t: 0.16, x: -0.5816, y: 1.3539, z: 8.9993 },
        { t: 0.176, x: -0.5477, y: 1.3319, z: 9.6109 },
        { t: 0.192, x: -0.5168, y: 1.3076, z: 10.218 },
        { t: 0.208, x: -0.4889, y: 1.281, z: 10.8205 },
        { t: 0.224, x: -0.4638, y: 1.2521, z: 11.4185 },
        { t: 0.24, x: -0.4417, y: 1.2209, z: 12.012 },
        { t: 0.256, x: -0.4226, y: 1.1874, z: 12.6009 },
        { t: 0.272, x: -0.4064, y: 1.1516, z: 13.1854 },
        { t: 0.288, x: -0.3932, y: 1.1135, z: 13.7653 },
        { t: 0.304, x: -0.3829, y: 1.0731, z: 14.3407 },
        { t: 0.32, x: -0.3755, y: 1.0304, z: 14.9115 },
        { t: 0.336, x: -0.3711, y: 0.9855, z: 15.4779 },
        { t: 0.352, x: -0.3696, y: 0.9382, z: 16.0397 },
        { t: 0.368, x: -0.3711, y: 0.8886, z: 16.597 },
        { t: 0.384, x: -0.3755, y: 0.8367, z: 17.1497 },
        { t: 0.4, x: -0.3829, y: 0.7826, z: 17.698 },
        { t: 0.411, x: -0.3897, y: 0.744, z: 18.0726 }
    ],
    [
        { t: 0, x: -1.0802, y: 1.3633, z: 2.5252 },
        { t: 0.016, x: -1.0348, y: 1.3729, z: 3.1245 },
        { t: 0.032, x: -0.9892, y: 1.3775, z: 3.7201 },
        { t: 0.048, x: -0.9435, y: 1.3773, z: 4.3119 },
        { t: 0.064, x: -0.8976, y: 1.3722, z: 4.9 },
        { t: 0.08, x: -0.8515, y: 1.3623, z: 5.4843 },
        { t: 0.096, x: -0.8053, y: 1.3475, z: 6.0649 },
        { t: 0.112, x: -0.7589, y: 1.3278, z: 6.6417 },
        { t: 0.128, x: -0.7124, y: 1.3032, z: 7.2147 },
        { t: 0.144, x: -0.6657, y: 1.2738, z: 7.784 },
        { t: 0.16, x: -0.6188, y: 1.2395, z: 8.3495 },
        { t: 0.176, x: -0.5718, y: 1.2003, z: 8.9113 },
        { t: 0.192, x: -0.5246, y: 1.1563, z: 9.4693 },
        { t: 0.208, x: -0.4773, y: 1.1073, z: 10.0236 },
        { t: 0.224, x: -0.4298, y: 1.0536, z: 10.5741 },
        { t: 0.24, x: -0.3821, y: 0.9949, z: 11.1208 },
        { t: 0.256, x: -0.3343, y: 0.9314, z: 11.6638 },
        { t: 0.272, x: -0.2863, y: 0.863, z: 12.203 },
        { t: 0.288, x: -0.2381, y: 0.7897, z: 12.7385 },
        { t: 0.304, x: -0.1898, y: 0.7115, z: 13.2702 },
        { t: 0.32, x: -0.1413, y: 0.6285, z: 13.7982 },
        { t: 0.336, x: -0.0927, y: 0.5406, z: 14.3224 },
        { t: 0.352, x: -0.0439, y: 0.4479, z: 14.8428 },
        { t: 0.368, x: 0.0051, y: 0.3503, z: 15.3595 },
        { t: 0.384, x: 0.0542, y: 0.2478, z: 15.8724 },
        { t: 0.4, x: 0.1035, y: 0.1404, z: 16.3816 },
        { t: 0.416, x: 0.153, y: 0.0281, z: 16.887 },
        { t: 0.432, x: 0.2026, y: -0.089, z: 17.3887 },
        { t: 0.448, x: 0.2523, y: -0.211, z: 17.8866 },
        { t: 0.4557, x: 0.2764, y: -0.2715, z: 18.1254 }
    ],
    [
        { t: 0, x: -1.1526, y: 1.4483, z: 2.5141 },
        { t: 0.016, x: -1.0646, y: 1.4478, z: 3.1446 },
        { t: 0.032, x: -0.9794, y: 1.444, z: 3.771 },
        { t: 0.048, x: -0.8971, y: 1.4369, z: 4.3935 },
        { t: 0.064, x: -0.8176, y: 1.4265, z: 5.0119 },
        { t: 0.08, x: -0.7409, y: 1.4128, z: 5.6263 },
        { t: 0.096, x: -0.6671, y: 1.3958, z: 6.2368 },
        { t: 0.112, x: -0.5961, y: 1.3754, z: 6.8432 },
        { t: 0.128, x: -0.5279, y: 1.3518, z: 7.4457 },
        { t: 0.144, x: -0.4626, y: 1.3249, z: 8.0441 },
        { t: 0.16, x: -0.4001, y: 1.2946, z: 8.6385 },
        { t: 0.176, x: -0.3404, y: 1.2611, z: 9.229 },
        { t: 0.192, x: -0.2836, y: 1.2242, z: 9.8154 },
        { t: 0.208, x: -0.2295, y: 1.1841, z: 10.3978 },
        { t: 0.224, x: -0.1783, y: 1.1406, z: 10.9763 },
        { t: 0.24, x: -0.13, y: 1.0939, z: 11.5507 },
        { t: 0.256, x: -0.0845, y: 1.0438, z: 12.1211 },
        { t: 0.272, x: -0.0418, y: 0.9904, z: 12.6876 },
        { t: 0.288, x: -0.0019, y: 0.9337, z: 13.25 },
        { t: 0.304, x: 0.0351, y: 0.8738, z: 13.8084 },
        { t: 0.32, x: 0.0693, y: 0.8105, z: 14.3629 },
        { t: 0.336, x: 0.1007, y: 0.7439, z: 14.9133 },
        { t: 0.352, x: 0.1292, y: 0.674, z: 15.4597 },
        { t: 0.368, x: 0.1549, y: 0.6008, z: 16.0022 },
        { t: 0.384, x: 0.1778, y: 0.5243, z: 16.5406 },
        { t: 0.4, x: 0.1979, y: 0.4445, z: 17.075 },
        { t: 0.416, x: 0.2151, y: 0.3613, z: 17.6054 },
        { t: 0.432, x: 0.2295, y: 0.2749, z: 18.1319 },
        { t: 0.433, x: 0.2303, y: 0.2692, z: 18.1657 }
    ]
]
